import { c as _c } from "react/compiler-runtime";
import { BadRequest } from '@systemeio/util';
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import { FunnelTabCard } from 'modules/funnels/funnel/components/funnel-tab-card';
import { TabContentLoader } from 'modules/funnels/funnel/components/tab-content-loader';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import { useWebinarRegistrationSettings } from 'modules/funnels/funnel/hooks/use-webinar-registration-settings';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React, { useEffect, useState } from 'react';
import { FormInputGroup, FormUrlPathInput, Hint, toast } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { getStateStatusIcon } from 'shared/utils/get-status-icon';
import { useFunnelStepsList } from '../../hooks/use-funnel-steps-list';
import { useBaseConfigurationTabFieldState, useUpdateBaseConfigurationTab } from '../../hooks/use-update-base-configuration-tab';
import { WebinarRegistrationEditErrorsInterface, WebinarRegistrationEditInterface, WebinarRegistrationFieldErrorResponseContentInterface, WebinarRegistrationInterface } from '../../types/webinar-registration-interface';
const defaultValues: WebinarRegistrationEditInterface = {
  name: '',
  page: {
    path: ''
  },
  webinar: {
    duration: 0
  }
};
const defaultErrors: WebinarRegistrationEditErrorsInterface = {
  name: '',
  page: {
    path: ''
  },
  webinar: {
    duration: ''
  }
};
interface WebinarRegistrationConfigurationTabProps {
  funnelStep: FunnelStepInterface;
  funnelId: FunnelId;
}
function WebinarRegistrationConfigurationTab(t0) {
  const $ = _c(82);
  const {
    funnelStep,
    funnelId
  } = t0;
  const {
    webinarRegistrationSettings,
    mutateWebinarRegistrationSettings
  } = useWebinarRegistrationSettings(funnelStep.id);
  const {
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  const {
    t
  } = useLocoTranslation();
  const {
    funnel
  } = useFunnel(funnelId);
  const [tempState, setTempState] = useState(defaultValues);
  const [errors, setErrors] = useState(defaultErrors);
  const [savedState, setSavedState] = useState(defaultValues);
  const t1 = `${FUNNELS_API}/steps/${funnelStep.id}/webinar-registration`;
  let t2;
  if ($[0] !== funnelId || $[1] !== funnelStep.id || $[2] !== t1) {
    t2 = {
      funnelStepId: funnelStep.id,
      funnelId,
      updateUrl: t1
    };
    $[0] = funnelId;
    $[1] = funnelStep.id;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    updateFetcher,
    isFetching
  } = useUpdateBaseConfigurationTab(t2);
  let t3;
  if ($[4] !== savedState || $[5] !== tempState) {
    t3 = {
      savedState,
      currentState: tempState
    };
    $[4] = savedState;
    $[5] = tempState;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    isNameChanged,
    isPagePathChanged,
    isWebinarDurationChanged,
    successState,
    setSuccessState
  } = useBaseConfigurationTabFieldState(t3);
  let t4;
  if ($[7] !== funnelStep.id || $[8] !== isNameChanged || $[9] !== isPagePathChanged || $[10] !== isWebinarDurationChanged || $[11] !== mutateFunnelStepsList || $[12] !== mutateWebinarRegistrationSettings || $[13] !== setSuccessState || $[14] !== tempState || $[15] !== updateFetcher) {
    t4 = async () => {
      ;
      try {
        setErrors(defaultErrors);
        await updateFetcher(tempState, async () => {
          setSuccessState(prev_0 => ({
            ...prev_0,
            name: isNameChanged,
            path: isPagePathChanged,
            webinarDuration: isWebinarDurationChanged
          }));
          setSavedState({
            ...tempState
          });
          await mutateWebinarRegistrationSettings(data => {
            if (data) {
              return {
                ...data,
                name: tempState.name,
                page: {
                  ...data.page,
                  path: tempState.page.path
                },
                webinar: {
                  ...data.webinar,
                  duration: tempState.webinar.duration
                }
              };
            }
          }, false);
          await mutateFunnelStepsList(data_0 => {
            if (data_0) {
              return data_0.map(dataFunnelStep => {
                if (dataFunnelStep.id === funnelStep.id) {
                  return {
                    ...dataFunnelStep,
                    name: tempState.name
                  };
                }
                return dataFunnelStep;
              });
            }
          }, false);
        });
      } catch (t5) {
        const e = t5;
        if (e instanceof BadRequest) {
          if (e.errors.common.length !== 0) {
            toast.error(e.errors.common.join(""));
          }
          if (e.errors.fields) {
            const errors_0 = e.errors.fields as unknown as WebinarRegistrationFieldErrorResponseContentInterface;
            setErrors(prev => ({
              ...prev,
              name: errors_0.name?.join(""),
              page: {
                path: errors_0.page?.path?.join("")
              },
              webinar: {
                duration: errors_0.webinar?.duration?.join("")
              }
            }));
          }
        }
      }
    };
    $[7] = funnelStep.id;
    $[8] = isNameChanged;
    $[9] = isPagePathChanged;
    $[10] = isWebinarDurationChanged;
    $[11] = mutateFunnelStepsList;
    $[12] = mutateWebinarRegistrationSettings;
    $[13] = setSuccessState;
    $[14] = tempState;
    $[15] = updateFetcher;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const handleSave = t4;
  let t5;
  let t6;
  if ($[17] !== webinarRegistrationSettings) {
    t5 = () => {
      if (webinarRegistrationSettings) {
        setTempState(prev_1 => ({
          ...prev_1,
          name: webinarRegistrationSettings.name,
          page: {
            path: webinarRegistrationSettings.page.path
          },
          webinar: {
            duration: webinarRegistrationSettings.webinar.duration
          }
        }));
        setSavedState(prev_2 => ({
          ...prev_2,
          name: webinarRegistrationSettings.name,
          page: {
            path: webinarRegistrationSettings.page.path
          },
          webinar: {
            duration: webinarRegistrationSettings.webinar.duration
          }
        }));
      }
    };
    t6 = [webinarRegistrationSettings];
    $[17] = webinarRegistrationSettings;
    $[18] = t5;
    $[19] = t6;
  } else {
    t5 = $[18];
    t6 = $[19];
  }
  useEffect(t5, t6);
  if (!webinarRegistrationSettings || !funnel || !funnelStep.page) {
    let t7;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <TabContentLoader />;
      $[20] = t7;
    } else {
      t7 = $[20];
    }
    return t7;
  }
  let t7;
  if ($[21] !== t) {
    t7 = t("global.name");
    $[21] = t;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const t8 = tempState.name;
  let t9;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = e_0 => setTempState(prev_3 => ({
      ...prev_3,
      name: e_0.target.value
    }));
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== handleSave || $[25] !== isNameChanged) {
    t10 = () => isNameChanged && handleSave();
    $[24] = handleSave;
    $[25] = isNameChanged;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const t11 = isFetching && isNameChanged;
  let t12;
  if ($[27] !== successState.name || $[28] !== t11) {
    t12 = getStateStatusIcon(t11, successState.name);
    $[27] = successState.name;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== errors.name || $[31] !== t10 || $[32] !== t12 || $[33] !== t7 || $[34] !== tempState.name) {
    t13 = <FormInputGroup required={true} label={t7} value={t8} onChange={t9} onBlur={t10} maxLength={256} statusIcon={t12} error={errors.name} />;
    $[30] = errors.name;
    $[31] = t10;
    $[32] = t12;
    $[33] = t7;
    $[34] = tempState.name;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t) {
    t14 = t("dashboard.funnel.configuration.webinar.duration_popover");
    $[36] = t;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t) {
    t15 = t("dashboard.funnel.configuration.webinar.duration");
    $[38] = t;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t14 || $[41] !== t15) {
    t16 = <Hint label={t14} className="text-text-primary">{t15}</Hint>;
    $[40] = t14;
    $[41] = t15;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  const t17 = tempState.webinar?.duration;
  let t18;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = e_1 => setTempState(prev_4 => ({
      ...prev_4,
      webinar: {
        duration: parseInt(e_1.target.value) || 0
      }
    }));
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== handleSave || $[45] !== isWebinarDurationChanged) {
    t19 = () => isWebinarDurationChanged && handleSave();
    $[44] = handleSave;
    $[45] = isWebinarDurationChanged;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  const t20 = isFetching && isWebinarDurationChanged;
  let t21;
  if ($[47] !== successState.webinarDuration || $[48] !== t20) {
    t21 = getStateStatusIcon(t20, successState.webinarDuration);
    $[47] = successState.webinarDuration;
    $[48] = t20;
    $[49] = t21;
  } else {
    t21 = $[49];
  }
  let t22;
  if ($[50] !== errors.webinar.duration || $[51] !== t16 || $[52] !== t17 || $[53] !== t19 || $[54] !== t21) {
    t22 = <FormInputGroup label={t16} type="number" value={t17} onChange={t18} onBlur={t19} maxLength={256} statusIcon={t21} error={errors.webinar.duration} />;
    $[50] = errors.webinar.duration;
    $[51] = t16;
    $[52] = t17;
    $[53] = t19;
    $[54] = t21;
    $[55] = t22;
  } else {
    t22 = $[55];
  }
  const t23 = tempState.page?.path;
  const t24 = funnel?.domain.domainName;
  let t25;
  if ($[56] !== t) {
    t25 = t("dashboard.funnel.configuration.webinar.url_path_popover");
    $[56] = t;
    $[57] = t25;
  } else {
    t25 = $[57];
  }
  let t26;
  if ($[58] !== t) {
    t26 = t("global.url_path");
    $[58] = t;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t25 || $[61] !== t26) {
    t27 = <Hint label={t25} className="text-text-primary">{t26}</Hint>;
    $[60] = t25;
    $[61] = t26;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  let t28;
  if ($[63] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = e_2 => setTempState(prev_5 => ({
      ...prev_5,
      page: {
        path: e_2.target.value
      }
    }));
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  let t29;
  if ($[64] !== handleSave || $[65] !== isPagePathChanged) {
    t29 = () => isPagePathChanged && handleSave();
    $[64] = handleSave;
    $[65] = isPagePathChanged;
    $[66] = t29;
  } else {
    t29 = $[66];
  }
  const t30 = funnelStep.inRunningSplitTest;
  const t31 = isFetching && isPagePathChanged;
  let t32;
  if ($[67] !== successState.path || $[68] !== t31) {
    t32 = getStateStatusIcon(t31, successState.path);
    $[67] = successState.path;
    $[68] = t31;
    $[69] = t32;
  } else {
    t32 = $[69];
  }
  let t33;
  if ($[70] !== errors.page.path || $[71] !== funnelStep.inRunningSplitTest || $[72] !== t23 || $[73] !== t24 || $[74] !== t27 || $[75] !== t29 || $[76] !== t32) {
    t33 = <FormUrlPathInput required={true} value={t23} domainName={t24} label={t27} onChange={t28} onBlur={t29} disabled={t30} statusIcon={t32} error={errors.page.path} />;
    $[70] = errors.page.path;
    $[71] = funnelStep.inRunningSplitTest;
    $[72] = t23;
    $[73] = t24;
    $[74] = t27;
    $[75] = t29;
    $[76] = t32;
    $[77] = t33;
  } else {
    t33 = $[77];
  }
  let t34;
  if ($[78] !== t13 || $[79] !== t22 || $[80] !== t33) {
    t34 = <><FunnelTabCard className="desktop:gap-3 flex flex-col gap-2">{t13}{t22}{t33}</FunnelTabCard></>;
    $[78] = t13;
    $[79] = t22;
    $[80] = t33;
    $[81] = t34;
  } else {
    t34 = $[81];
  }
  return t34;
}
export default WebinarRegistrationConfigurationTab;